import React from "react";
import { Edit3, Trash2, DollarSign, Calendar, User, Clock } from "lucide-react";

const IndexRow = ({ workshop }) => (
  <>
    <td className="px-8 py-6 rounded-l-xl">
      <span className="text-xs font-black text-stone-800 dark:text-white uppercase tracking-tight block max-w-[200px] truncate">
        {workshop.title}
      </span>
    </td>
    <td className="px-6 py-6">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
          <User size={12} className="text-amber-700" />
        </div>
        <span className="text-[10px] text-slate-600 dark:text-stone-300 font-bold uppercase tracking-tight">
          {workshop.speaker}
        </span>
      </div>
    </td>
    <td className="px-6 py-6">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1.5 text-stone-800 dark:text-stone-200 font-bold text-[10px] uppercase tracking-tighter">
          <Calendar size={12} className="text-blue-600" />
          {workshop.startDate === workshop.endDate ? workshop.startDate : `${workshop.startDate} - ${workshop.endDate}`}
        </div>
        <div className="flex items-center gap-1.5 text-stone-400 font-bold text-[9px] uppercase tracking-widest">
          <Clock size={11} />
          {workshop.time}
        </div>
      </div>
    </td>
    <td className="px-6 py-6 text-center">
      <div className="inline-flex items-center gap-1 px-3 py-1 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 rounded-full font-black text-[10px]">
        <DollarSign size={10} />
        {workshop.price.toLocaleString()}
      </div>
    </td>
    <td className="px-6 py-6 text-center font-black text-[11px] text-stone-800 dark:text-stone-200">
      {workshop.quota} PAX
    </td>
    <td className="px-6 py-6 text-center rounded-r-xl">
      <div className="flex items-center justify-center gap-2">
        <button className="p-2.5 bg-white/50 dark:bg-white/5 hover:bg-blue-100 text-stone-400 hover:text-blue-600 rounded-xl transition-all shadow-sm">
          <Edit3 size={14} />
        </button>
        <button className="p-2.5 bg-white/50 dark:bg-white/5 hover:bg-red-100 text-stone-400 hover:text-red-600 rounded-xl transition-all shadow-sm">
          <Trash2 size={14} />
        </button>
      </div>
    </td>
  </>
);

export default IndexRow;